import * as React from 'react';

export type Props = {
    width: string;
    height: string;
    style?: React.CSSProperties;
};

export const RightTriangle = (props: Props) =>
    <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 443.307 443.306"
        { ...props }
    >
        <g>
            { /* tslint:disable */ }
            <path d="M415.934,212.799L36.788,2.097C32.411-0.377,28.65-0.661,25.51,1.242c-3.14,1.902-4.708,5.328-4.708,10.276V431.78 c0,4.952,1.569,8.381,4.708,10.284c3.14,1.902,6.901,1.622,11.278-0.855l379.146-210.703c4.381-2.478,6.571-5.434,6.571-8.856 C422.505,218.224,420.314,215.274,415.934,212.799z"/>
            { /* tslint:enable */ }
        </g>
    </svg>
;
        


// WEBPACK FOOTER //
// ./src/ui/shapes/RightTriangle.tsx